import { useState } from "react";

const PASSWORD = "qubo2026";

export default function PasswordGate({ children }) {
  const [unlocked, setUnlocked] = useState(
    () => sessionStorage.getItem("qubo_unlocked") === "1"
  );
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);
  const [shake, setShake] = useState(false);

  if (unlocked) return children;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value === PASSWORD) {
      sessionStorage.setItem("qubo_unlocked", "1");
      setUnlocked(true);
    } else {
      setError(true);
      setShake(true);
      setValue("");
      setTimeout(() => setShake(false), 600);
    }
  };

  return (
    <div style={{
      position: "fixed", inset: 0,
      background: "#000",
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      gap: "2.5rem", zIndex: 9999,
    }}>
      <img
        src="/logo.png"
        alt="Qubo"
        style={{ width: 600 }}
      />
      <form
        onSubmit={handleSubmit}
        style={{
          display: "flex", flexDirection: "column",
          alignItems: "center", gap: "1rem",
          animation: shake ? "shake 0.6s ease" : "none",
        }}
      >
        <input
          type="password"
          value={value}
          onChange={(e) => { setValue(e.target.value); setError(false); }}
          placeholder="Contraseña"
          autoFocus
          style={{
            background: "transparent",
            border: `1px solid ${error ? "#ef4444" : "#444"}`,
            borderRadius: 6,
            color: "#fff",
            padding: "0.65rem 1.25rem",
            fontSize: "1rem",
            outline: "none",
            width: 220,
            textAlign: "center",
            letterSpacing: "0.1em",
            transition: "border-color 0.2s",
          }}
        />
        {error && (
          <span style={{ color: "#ef4444", fontSize: "0.8rem" }}>
            Contraseña incorrecta
          </span>
        )}
        <button
          type="submit"
          style={{
            background: "#fff", color: "#000",
            border: "none", borderRadius: 6,
            padding: "0.6rem 2rem",
            fontSize: "0.9rem", fontWeight: 600,
            cursor: "pointer", width: 220,
          }}
        >
          Ingresar
        </button>
      </form>
      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20% { transform: translateX(-8px); }
          40% { transform: translateX(8px); }
          60% { transform: translateX(-6px); }
          80% { transform: translateX(6px); }
        }
      `}</style>
    </div>
  );
}
